export default __webpack_public_path__ + "ce257b5cebdacf9978547450e3889251.svg";